<template>
    <div class="dialog-actions">
        <button v-if="!hideCancel" type="button" class="dialog-cancel" @click="$emit('cancel')">
            {{ cancelLabel || $t('common.cancel') }}
        </button>
        <slot name="extra" />
        <v-btn depressed tile :color="confirmColor" class="dialog-confirm"
            :class="{ 'black--text': confirmColor === 'primary' }" :disabled="disabled" :loading="loading"
            @click="$emit('confirm')">
            {{ confirmLabel }}
        </v-btn>
    </div>
</template>

<script>
export default {
    name: "DialogActions",
    props: {
        confirmLabel: {
            type: String,
            default: '',
        },
        cancelLabel: {
            type: String,
            default: '',
        },
        loading: {
            type: Boolean,
            default: false,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        confirmColor: {
            type: String,
            default: 'primary',
        },
        hideCancel: {
            type: Boolean,
            default: false,
        },
    },
}
</script>

<style scoped>
.dialog-actions {
    display: flex;
}

.dialog-cancel {
    padding: 0 20px;
    height: 52px;
    background: none;
    border: none;
    border-right: 1px solid var(--v-outline-base);
    font-family: inherit;
    font-size: 14px;
    font-weight: 500;
    color: var(--v-txtSecondary-base);
    cursor: pointer;
    flex-shrink: 0;
    transition: color 0.15s;
}

.dialog-cancel:hover {
    color: var(--v-txtPrimary-base);
}

.dialog-confirm {
    flex: 1;
    height: 52px !important;
    border-radius: 0 !important;
    font-weight: 700;
}
</style>
